import type { ExternalMessageLoader } from '@canvas/intl';
import type { SupportedLocale } from '@canvas/intl-types';

export function combineExternalMessages(
  ...maps: Record<SupportedLocale, ExternalMessageLoader[]>[]
) {
  return maps.reduce((acc, map) => {
    for (const localeStr in map) {
      const locale = localeStr as SupportedLocale;
      if (acc[locale]) {
        acc[locale].push(...map[locale]);
      } else {
        acc[locale] = map[locale];
      }
    }
    return acc;
  }, {} as Record<SupportedLocale, ExternalMessageLoader[]>);
}

export function pickExternalMessages<TKey extends string>(
  ...maps: { name: TKey; map: Record<SupportedLocale, ExternalMessageLoader[]> }[]
): Record<SupportedLocale, Record<TKey, ExternalMessageLoader[]>> {
  return maps.reduce((acc, { name, map }) => {
    for (const localeStr in map) {
      const locale = localeStr as SupportedLocale;
      if (!acc[locale]) {
        acc[locale] = {} as Record<TKey, ExternalMessageLoader[]>;
      }

      acc[locale][name] = map[locale];
    }
    return acc;
  }, {} as Record<SupportedLocale, Record<TKey, ExternalMessageLoader[]>>);
}
